"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceCommentSaveRequest_1 = require("../model/PriceCommentSaveRequest");

var PriceCommentSaveRequestConverter_1 = require("./PriceCommentSaveRequestConverter");
/**
 * Default implementation of {@link PriceCommentSaveRequest}
 *
 * @author JMr
 */


var PriceCommentSaveRequestConverterImpl =
/*#__PURE__*/
function (_PriceCommentSaveRequ) {
  _inherits(PriceCommentSaveRequestConverterImpl, _PriceCommentSaveRequ);

  function PriceCommentSaveRequestConverterImpl() {
    _classCallCheck(this, PriceCommentSaveRequestConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceCommentSaveRequestConverterImpl).apply(this, arguments));
  }

  _createClass(PriceCommentSaveRequestConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceCommentSaveRequest_1.PriceCommentSaveRequest(PriceCommentSaveRequest_1.PriceCommentSaveRequest.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), PriceCommentSaveRequest_1.PriceCommentSaveRequest.schema.text.valueOfField(source), PriceCommentSaveRequest_1.PriceCommentSaveRequest.schema.persistent.valueOfField(source), source.deleteOn ? conversions.toDate(source.deleteOn) : null);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        text: source.text,
        persistent: source.persistent,
        deleteOn: source.deleteOn ? conversions.fromDate(source.deleteOn) : null
      });
      return document;
    }
  }]);

  return PriceCommentSaveRequestConverterImpl;
}(PriceCommentSaveRequestConverter_1.PriceCommentSaveRequestConverter);

exports.PriceCommentSaveRequestConverterImpl = PriceCommentSaveRequestConverterImpl;